<template>
  <form @submit.prevent="submitComponent">
    <div class="row">
      <div class="col-12 mt-4 mb-5">
        <!-- INPUT NAME -->
        <float-input
          v-if="!editComponent"
          :input="input.name"
          label="Input Name"
          :is-required="true"
          @newValue="input.name = $event"
        ></float-input>
        <float-input
          v-else
          :input="input.name"
          label="Input Name"
          :is-required="true"
          @newValue="input.new_name = $event"
        ></float-input>
      </div>
      <!-- INPUT TYPE -->
      <div class="col-12 mb-5">
        <float-input
          :input="input.type"
          label="Input type"
          inputType="select"
          :is-required="true"
          v-on:newValue="input.type = $event"
        >
          <option v-for="(type, key) in inputOption" :key="key" :value="type">
            {{ type }}
          </option>
        </float-input>
      </div>

      <!-- INPUT TYPE CONFIGURATION -->
      <!-- LOGIC WATCHER -->
      <div v-if="input.type === 'Logic Watcher'" class="col-12 mb-5">
        <div v-if="editComponent">
          <float-input
            :input="input.logic_watcher"
            label="Selected Logic Watcher"
            :isReadonly="editComponent"
          >
          </float-input>
        </div>
        <div v-else>
          <float-input
            :input="input.logic_watcher"
            label="Select Logic Watcher"
            inputType="select"
            :is-required="true"
            v-on:newValue="input.logic_watcher = $event"
          >
            <option
              v-for="(type, key) in logicWatchers"
              :key="key"
              :value="type"
            >
              {{ type }}
            </option>
          </float-input>
        </div>
      </div>
      <div
        v-if="input.type === 'Logic Watcher' && this.input.radios.length > 0"
        class="col-12"
      >
        <div
          class="float-input-wrapper"
          v-for="tag in input.radios"
          :key="tag.name"
        >
          <div>
            <input
              type="text"
              placeholder="Enter Tag"
              class="tag-input__radio_tag"
              :value="tag.name"
              readonly="true"
              style="display: none"
            />
            {{ humanize(tag.name) }}
          </div>
          <textarea
            :placeholder="`Enter Value for Option: ${humanize(tag.name)}`"
            class="tag-input__textarea"
            rows="5"
            :value="tag.value"
            @keyup="populateRadioValue(tag.name, $event)"
          />
        </div>

        <hr />
      </div>

      <!-- NUMBER WITH TRANSLATION -->
      <div v-if="input.type === 'Number with Translation'" class="col-12 mb-5">
        <float-input
          :input="input.output_format"
          label="Output Format"
          inputType="text"
          :is-required="true"
          :default-value="'{val}{trans}'"
          v-on:newValue="input.output_format = $event"
        >
        </float-input>
        <div>
          <small>
            Output Format must contain {val}, {trans}
            <br />{val} will be input by user, the system will translate the
            value into {trans} upon PDF render <br /><br />E.g.: RM {trans} (RM
            {val}) will appear as RM One (RM 1)
          </small>
        </div>
      </div>
      <!-- TAGS FOR INPUT TYPE: RADIO -->
      <div v-if="input.type === 'Radio'" class="col-12">
        <div
          v-for="(tag, index) in input.radios"
          :key="tag.name"
          class="tag-input__radio"
        >
          <span @click="removeRadioTag(index)" class="text-red cursor-pointer"
            >X</span
          >
          {{ tag.name }}: {{ tag.value }}
        </div>
        <div class="float-input-wrapper">
          <div>
            <input
              type="text"
              placeholder="Enter Tag"
              class="tag-input__radio_tag"
              v-model="radio_tag"
            />
          </div>
          <textarea
            placeholder="Enter Tag Value"
            class="tag-input__textarea"
            rows="5"
            v-model="radio_value"
          />
        </div>
        <button class="btn btn-primary" @click="addRadioTag">Add Radio</button>
        <hr />
      </div>
      <!-- TAGS FOR INPUT TYPE: SELECT OPTION | CHECKBOX | RADIO -->
      <div
        v-if="input.type === 'Select Option' || input.type === 'checkbox'"
        class="col-12 mb-5"
      >
        <div class="float-input-wrapper">
          <div
            v-for="(tag, index) in input.tags"
            :key="tag"
            class="tag-input__tag"
          >
            <span @click="removeTag(index)">x</span>
            {{ tag }}
          </div>
          <input
            type="text"
            placeholder="Enter a Tag"
            class="tag-input__text"
            @keydown.enter="addTag"
            @keydown.188="addTag"
          />
        </div>
      </div>
      <!-- REQUIRED -->
      <!-- <div class="col-12 mb-5">
        <float-input
          :input="input.required"
          label="Required"
          inputType="select"
          v-on:newValue="input.required = $event"
        >
          <option :value="true">Yes</option>
          <option :value="false">No</option>
        </float-input>
      </div> -->
      <!-- GROUP -->
      <div class="col-12 mb-5">
        <float-input
          :input="input.group"
          label="Group"
          inputType="select"
          :is-required="true"
          v-on:newValue="input.group = $event"
        >
          <option
            v-for="(group, key) in groupOption"
            v-bind:key="key"
            :value="group.id"
          >
            {{ group.name }}
          </option>
        </float-input>
      </div>
      <!-- SEQUENCE -->
      <div class="col-12 mb-5">
        <float-input
          inputType="number"
          :input="input.sequence"
          label="Sequence"
          @newValue="input.sequence = $event"
        ></float-input>
      </div>
      <div class="col-12 mb-5">
        <input type="checkbox" v-model="input.hideFromResponse">
        <label>Hide</label>
      </div>

      <div class="col-12 mb-2">
        <button v-if="editComponent" class="btn-submit btn-primary">
          Save Component
        </button>
        <button v-else class="btn-submit btn-primary">Add Component</button>
      </div>
    </div>
  </form>
</template>
<script>
import WatcherData from "../../../lib/logic-watcher-data.js";
export default {
  props: {
    editComponent: { type: Boolean, default: false },
    groupOption: { type: Array, default: () => [] },
    componentProps: { type: Object, default: () => {} },
    componentList: { type: Array, default: () => [] },
  },
  data() {
    return {
      radio_tag: "",
      radio_value: "",
      inputOption: [
        "Text",
        "Textarea",
        "WYSIWYG",
        "Logic Watcher",
        "Date",
        "Number",
        "Number with RM Currency",
        "Number with Translation",
        "Radio",
        "Select Option",
      ],
      logicWatchers: WatcherData.map((el) => el["name"]),
      requiredOption: ["true", "false"],
      input: {
        type: "",
        name: "",
        sequence: "",
        group: "",
        logic_watcher: "",
        output_format: "",
        tags: [],
        radios: [],
        new_name: "",
        required: "",
        hideFromResponse: false
      },
    };
  },
  watch: {
    componentProps() {
      if (this.componentProps) {
        this.input = this.componentProps;
      }
    },
    "input.logic_watcher": {
      handler(val) {
        if (!this.editComponent) {
          this.input.radios = [];
          for (var x of WatcherData) {
            if (val === x["name"]) {
              this.seedRadioTag(x["values"]);
              break;
            }
          }
        }
      },
    },
  },
  methods: {
    submitComponent() {
      if (!this.validateOutputFormat()) return;

      if (this.editComponent) {
        // UPDATE COMPONENT
        var oldName = this.input.name;
        var newName = this.input.new_name;

        if (
          oldName !== newName &&
          this.validateComponentName(this.input.new_name)
        ) {
          return;
        }

        var editor = document.getElementsByClassName(
          "codex-editor__redactor"
        )[0];

        editor.querySelectorAll("code.js-handlebar").forEach((code) => {
          if (code.innerHTML == `{{ ${oldName} }}`) {
            code.innerHTML = `{{ ${newName} }}`;
          }
        });

        this.input.name = this.input.new_name;
        $("#editComponent-modal").modal("hide");
      } else {
        // CREATE COMPONENT
        if (this.validateComponentName(this.input.name)) return;
        this.$emit("newComponent", this.input);
        $("#addcomponent-modal").modal("hide");
        setTimeout(() => {
          this.removeInput();
        }, 300);
      }
    },
    validateOutputFormat() {
      if (this.input.type === "Number with Translation") {
        if (
          this.input.output_format.includes("{val}") &&
          this.input.output_format.includes("{trans}")
        ) {
          return true;
        } else {
          alert(
            "Output format must contain both {val} & {trans} placeholders!"
          );
          return false;
        }
      } else if (this.input.type === "Number with RM Currency") {
        this.input.output_format = "RM <span class='currency-val'>{val}</span>";
      }
      return true;
    },
    validateComponentName(entry) {
      if (!entry || typeof entry !== "string") return false;
      // Check if new component name already exist / valid?
      var existingComponents = this.componentList.map(
        (component) => component.name
      );
      if (
        existingComponents.includes(entry) ||
        ["components", "groups"].includes(entry.toLowerCase())
      ) {
        // Raise alert is component name already exist
        alert(
          "A component with this input name already exist. Please use a different input name for this component."
        );
        return true;
      }
      return false;
    },
    removeInput() {
      this.input = {
        type: "",
        logic_watcher: "",
        name: "",
        sequence: "",
        group: "",
        radios: [],
        tags: [],
      };
    },
    addTag(event) {
      event.preventDefault();
      var val = event.target.value.trim();
      if (val.length > 0) {
        this.input.tags.push(val);
        event.target.value = "";
      }
    },
    removeTag(index) {
      this.input.tags.splice(index, 1);
    },
    addRadioTag(event) {
      event.preventDefault();
      // validate uniq radio tag name
      if (
        this.input.radios.map((tag) => tag.name).indexOf(this.radio_tag) >= 0
      ) {
        alert(
          "A radio with this tag name already exist. Please use a different tag name for this radio."
        );
      } else {
        this.input.radios.push({
          name: this.radio_tag,
          value: this.radio_value,
        });
        this.radio_tag = "";
        this.radio_value = "";
      }
    },
    removeRadioTag(index) {
      this.input.radios.splice(index, 1);
    },
    seedRadioTag(array) {
      for (var x of array) {
        this.input.radios.push({ name: x, value: "" });
      }
    },
    populateRadioValue(tag, event) {
      var i = this.input.radios.map((el) => el.name).indexOf(tag);
      this.input.radios[i].value = event.target.value;
    },
    humanize(str) {
      return str
        .replace(/^[\s_]+|[\s_]+$/g, "")
        .replace(/[_\s]+/g, " ")
        .replace(/^[a-z]/, function (m) {
          return m.toUpperCase();
        });
    },
  },
};
</script>
<style scoped>
.tag-input__tag {
  height: 30px;
  float: left;
  margin-right: 10px;
  background-color: #eee;
  margin-top: 10px;
  line-height: 30px;
  padding: 0 5px;
  border-radius: 5px;
}

.tag-input__tag > span,
.cursor-pointer {
  cursor: pointer;
  opacity: 0.75;
}

.tag-input__text {
  border: none;
  outline: none;
  font-size: 0.9em;
  line-height: 50px;
  background: none;
}
.tag-input__radio {
  background-color: #eee;
  margin-bottom: 10px;
  line-height: 30px;
  padding: 0 5px;
  border-radius: 5px;
}
.tag-input__radio_tag {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  width: 100%;
  outline: none;
  font-size: 0.9em;
  line-height: 20px;
  background: none;
}
.tag-input__textarea {
  border: 0;
  width: 100%;
  outline: none;
  font-size: 0.9em;
  background: none;
}
</style>
